import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { auth } from "../firebase";

const Login = () => {
  const [err, setErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (error) {
      console.error(error);
      setErr(true);
    }
  };

  return (
    <div className="register-page login-page">
      <div className="register-bg login-bg" aria-hidden="true">
        <div className="register-bg__dots register-bg__dots--tl" />
        <div className="register-bg__dots register-bg__dots--tr" />
        <div className="register-bg__curve register-bg__curve--1" />
        <div className="register-bg__curve register-bg__curve--2" />
        <div className="register-bg__dot register-bg__dot--1" />
        <div className="register-bg__dot register-bg__dot--2" />
        <div className="register-bg__dot register-bg__dot--3" />
      </div>

      <header className="register-header login-header">
        <div className="register-brand">
          <span className="register-brand__icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H6L10 22L14 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                fill="currentColor"
              />
              <circle cx="8" cy="10" r="1.2" fill="white" />
              <circle cx="12" cy="10" r="1.2" fill="white" />
              <circle cx="16" cy="10" r="1.2" fill="white" />
            </svg>
          </span>
          <span className="register-brand__text">Chat Cafe</span>
        </div>
      </header>

      <div className="register-layout login-layout">
        <section className="register-left login-left">
          <span className="register-badge login-badge">👋 Welcome back!</span>
          <h1 className="register-headline login-headline">
            Pick up your{" "}
            <span className="register-headline__accent">conversations</span>{" "}
            right where you left off.
          </h1>
          <p className="register-subtext login-subtext">
            Sign in to access your chats, messages, and everything in one
            intelligent workspace.
          </p>

          <ul className="register-features login-features">
            <li className="register-feature">
              <span className="register-feature__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H6L10 22L14 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div>
                <strong>Continue Seamlessly</strong>
                <p>All your conversations, synced and always available.</p>
              </div>
            </li>
            <li className="register-feature">
              <span className="register-feature__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="9"
                    cy="7"
                    r="3"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <circle
                    cx="17"
                    cy="8"
                    r="2.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M3 19C3 16.24 5.69 14 9 14C12.31 14 15 16.24 15 19M15 17.5C15 15.57 16.34 14 18 14C19.66 14 21 15.57 21 17.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <div>
                <strong>Stay in the Loop</strong>
                <p>Never miss a message or important update.</p>
              </div>
            </li>
            <li className="register-feature">
              <span className="register-feature__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2L4 6V12C4 16.42 7.58 20.24 12 22C16.42 20.24 20 16.42 20 12V6L12 2Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 12L11 14L15 10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div>
                <strong>Your Data, Your Control</strong>
                <p>Enterprise-grade security to keep you and your data safe.</p>
              </div>
            </li>
            <li className="register-feature">
              <span className="register-feature__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="4"
                    width="18"
                    height="12"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M8 20H16"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12 16V20"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <div>
                <strong>Access Anywhere</strong>
                <p>Use Chat Cafe on any device, anytime, from anywhere.</p>
              </div>
            </li>
          </ul>
        </section>

        <section className="register-center login-center">
          <div className="register-card login-card">
            <div className="register-card__header login-card__header">
              <span className="register-card__logo login-card__logo">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H6L10 22L14 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                    fill="currentColor"
                  />
                  <circle cx="8" cy="10" r="1.2" fill="white" />
                  <circle cx="12" cy="10" r="1.2" fill="white" />
                  <circle cx="16" cy="10" r="1.2" fill="white" />
                </svg>
              </span>
              <h2 className="register-card__title login-card__title">
                Welcome back
              </h2>
              <p className="register-card__subtitle login-card__subtitle">
                Login to continue your conversations
              </p>
            </div>

            <form className="register-form login-form" onSubmit={handleSubmit}>
              <div className="register-field login-field">
                <label htmlFor="email">Email Address</label>
                <div className="register-input login-input">
                  <span className="register-input__icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3"
                        y="5"
                        width="18"
                        height="14"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M3 7L12 13L21 7"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email address"
                  />
                </div>
              </div>

              <div className="register-field login-field">
                <label htmlFor="password">Password</label>
                <div className="register-input login-input">
                  <span className="register-input__icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="5"
                        y="11"
                        width="14"
                        height="10"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                  />
                  <span
                    className="login-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                    >
                      <path
                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>

              <div className="login-options">
                <label className="login-remember">
                  <input type="checkbox" name="remember" />
                  <span className="login-remember-text">Remember me</span>
                </label>
                <a href="#" className="login-forgot">
                  Forgot password?
                </a>
              </div>

              <button className="register-button login-button" type="submit">
                <span>Sign in</span>
                <span className="register-button__arrow login-button__arrow">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12H19M19 12L13 6M19 12L13 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>

              {err && (
                <span className="register-error">Something went wrong</span>
              )}
            </form>

            <div className="login-divider">
              <span className="login-divider__text">or</span>
            </div>

            <p className="register-footer login-footer">
              Don't have an account?{" "}
              <span className="last">
                <Link to="/register">Register</Link>
              </span>
            </p>
          </div>
        </section>

        <aside className="register-preview login-preview" aria-hidden="true">
          <div className="register-preview__panel login-preview__panel">
            <div className="register-preview__header login-preview__header">
              <span className="register-preview__brand-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H6L10 22L14 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <div>
                <strong>Chat Cafe</strong>
                <span className="register-preview__status">
                  <span className="register-preview__dot" />
                  Online
                </span>
              </div>
            </div>

            <div className="register-preview__messages login-preview__messages">
              <div className="register-preview__msg">
                <span className="register-preview__avatar register-preview__avatar--1">
                  A
                </span>
                <div className="register-preview__msg-body">
                  <div className="register-preview__msg-top">
                    <strong>Alice Johnson</strong>
                    <span>2m</span>
                  </div>
                  <p>Hey there! 👋</p>
                </div>
              </div>

              <div className="register-preview__msg">
                <span
                  className="register-preview__avatar register-preview__avatar--2"
                  style={{
                    background: "linear-gradient(135deg, #475569, #334155)",
                  }}
                >
                  D
                </span>
                <div className="register-preview__msg-body">
                  <div className="register-preview__msg-top">
                    <strong>Design Team</strong>
                    <span>12m</span>
                  </div>
                  <p>Project update</p>
                </div>
              </div>

              <div className="register-preview__msg">
                <span
                  className="register-preview__avatar register-preview__avatar--3"
                  style={{
                    background: "linear-gradient(135deg, #10b981, #059669)",
                  }}
                >
                  J
                </span>
                <div className="register-preview__msg-body">
                  <div className="register-preview__msg-top">
                    <strong>John Smith</strong>
                    <span>1h</span>
                  </div>
                  <p>Let's catch up</p>
                </div>
              </div>
            </div>

            <div className="register-preview__welcome login-preview__welcome">
              <span className="register-preview__welcome-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H6L10 22L14 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <div>
                <strong>Welcome back! 👋</strong>
                <p>Let's continue your journey. · just now</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Login;
